import { Component, OnInit } from '@angular/core';
import {DashboardExchangerateComponent} from '../dash-board/dashboard-exchangerate/dashboard-exchangerate.component';
@Component({
  selector: 'app-exchange-rate',
  templateUrl: './exchange-rate.component.html',
  styleUrls: ['./exchange-rate.component.css']
})
export class ExchangeRateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/exchange-rate/exchange-rate.component.ts